import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik';
import allowNumbersOnly, { AllowFloats, handlePaste } from '../../CommonUtils/CommonValidations';
import { FaEye, FaRegTrashAlt } from 'react-icons/fa';
import { VscDiffAdded } from 'react-icons/vsc';
import * as bie from "react-bootstrap";
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import * as Yup from 'yup';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import moment from 'moment';
import { viewImage } from '../../CommonUtils/viewImage';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { getYearsDynamicBasedOnInput } from '../../CommonUtils/CommonServices';
import { GetCollegeType } from '../../Reducers/AffiliationCommonservice';
import { useSelector } from 'react-redux';


export default function AfflRegisteredDeedDetails() {
    const LandType = useSelector((state) => state?.commonMastersReducer?.CollegeType);

    const AfiliationFeeDueValidation = Yup.object({
        collAccommodation: Yup.string().required(ERROR_MSG).nullable(),
        noOfYearsLeased: Yup.string().when('collAccommodation', {
            is: 'false',
            then: Yup.string().required(ERROR_MSG),
            otherwise: Yup.string().notRequired(),
        }),
        leasedDate: Yup.string().when('collAccommodation', {
            is: 'false',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired(),
        }),
        leasedArea: Yup.string().when('collAccommodation', {
            is: 'false',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired(),
        }),

        details: Yup.array().of(Yup.object().shape({
            sroSubRegistrarName: Yup.string().required(ERROR_MSG).nullable(),
            regYear: Yup.string().required(ERROR_MSG).nullable(),
            regDocNo: Yup.string().required(ERROR_MSG).nullable(),
            regDocFromIgrs: Yup.string().required(ERROR_MSG).nullable(),
        })),
    })
    const RegDeedFormik = useFormik({
        initialValues: {
            collAccommodation: "",
            noOfYearsLeased: "",
            leasedDate: "",
            leasedArea: "",
            details: [
                {

                    sroSubRegistrarName: "",
                    regYear: "",
                    regDocNo: "",
                    regDocFromIgrs: "",

                }
            ]
        },
        validationSchema: AfiliationFeeDueValidation,

        onSubmit: (values) => {
            const processedValues = {
                collAccommodation: (values?.collAccommodation || ''),
                leasedDate: (values?.leasedDate || ''),
                noOfYearsLeased: parseInt(values?.noOfYearsLeased, 10) || '',
                leasedArea: parseInt(values?.leasedArea, 10) || '',
                details: values.details.map(detail => ({
                    ...detail,
                }))
            };
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveRegisteredDeedDetails`;
                    CommonAxiosPost(url, processedValues).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetRegDeedData();

                        } else {
                            failureAlert("Submission Failed.");
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });
        }
    })
    const [SroData, setSroData] = useState([]);
    function GetSro() {
        let url = config.url.API_URL + `getsroList`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setSroData(res?.data?.srolist);


            } else {
                setSroData([])

            }
        })
    }
    const [DeedData, setDeedData] = useState([]);
    function GetRegDeedData() {
        let url = config.url.API_URL + "getRegisterdeed";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setDeedData(res?.data?.details)


                const LeasedDate = res?.data?.leasedDate && moment(res?.data?.leasedDate,
                    'DD/MM/YYYY', true).isValid() ? moment(res?.data?.leasedDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                RegDeedFormik?.setFieldValue('collAccommodation', res?.data?.collAccommodation === "true" ?
                    'true' : res?.data?.collAccommodation === "false" ? 'false' :
                        (res?.data?.collAccommodation == null || res?.data?.collAccommodation === '' ? '' : 'false')
                );
                RegDeedFormik?.setFieldValue(`noOfYearsLeased`, res?.data?.noOfYearsLeased !== null ? res?.data?.noOfYearsLeased : "");
                RegDeedFormik?.setFieldValue(`leasedDate`, LeasedDate ?? '', false);
                RegDeedFormik?.setFieldValue(`leasedArea`, res?.data?.leasedArea !== null ? res?.data?.leasedArea : "");
                res?.data?.details?.forEach((regdeed, i) => {
                    RegDeedFormik?.setFieldValue(`details[${i}].sroSubRegistrarName`, regdeed?.sroSubRegistrarName);
                    RegDeedFormik?.setFieldValue(`details[${i}].regYear`, regdeed?.regYear);
                    RegDeedFormik?.setFieldValue(`details[${i}].regDocNo`, regdeed?.regDocNo);
                    RegDeedFormik?.setFieldValue(`details[${i}].regDocFromIgrs`, regdeed?.regDocFromIgrs);


                })

            } else {
                RegDeedFormik.setFieldValue("details", [{
                    sroSubRegistrarName: "",
                    regYear: "",
                    regDocNo: "",
                    regDocFromIgrs: "",

                }]);


            }
        })
    }
    useEffect(() => {
        GetSro();
        GetRegDeedData();
        GetCollegeType();

    }, [])

    useEffect(() => {

        if (DeedData) {
            const dataitialValues = DeedData?.map(course => ({
                sroSubRegistrarName: course?.sroSubRegistrarName,
                regYear: course?.regYear,
                regDocNo: course?.regDocNo,
                regDocFromIgrs: course?.regDocFromIgrs,
            }));
            RegDeedFormik.setValues({ ...RegDeedFormik?.values, details: dataitialValues });
        }
    }, [DeedData]);
    return (
        <>

            <CommonFormHeading heading="Registered Deed Details" />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">

                    <FormikProvider value={RegDeedFormik}>
                        <Form onChange={RegDeedFormik.handleChange} onSubmit={RegDeedFormik.handleSubmit} className='affl-form'>
                            <bie.Row className="px-2 pt-3 mb-3">
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>College building in which accommodation</label>
                                        <Field as='select' name="collAccommodation" className='form-control mb-2' onChange={(e) => {
                                            RegDeedFormik?.setFieldValue("noOfYearsLeased", "")
                                            RegDeedFormik?.setFieldValue("leasedDate", "")
                                            RegDeedFormik?.setFieldValue("leasedArea", "")

                                        }}>
                                            <option value="">--Select--</option>
                                            <option value="false">Leased</option>
                                            <option value="true">Own</option>
                                        </Field>
                                        <ErrorMessage name="collAccommodation" component="div" className="text-error" />
                                    </bie.Col>
                                    {RegDeedFormik?.values?.collAccommodation == "false" ? (<>
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                            <label className='mb-1 field-mandatory' >Number of Years running in Leased Accommodation:</label>
                                            <Field type='text' name="noOfYearsLeased" className='form-control mb-2' onKeyPress={(e) => { AllowFloats(e); }}
                                                onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="noOfYearsLeased" component="div" className="text-error" />
                                        </bie.Col>
                                    </>) : null}
                                    {RegDeedFormik?.values?.collAccommodation == "false" ? (<>
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                            <label className='mb-1 field-mandatory'>Registered Lease deed Valid upto date</label>
                                            <Field type='date' name="leasedDate" className='form-control mb-2 mt-xl-3 mt-xxl-0' onKeyDown={(e) => { e.preventDefault() }} min={new Date().toISOString().split('T')[0]} />

                                            <ErrorMessage name="leasedDate" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                            <label className='mb-1 field-mandatory'>Leased Builtup Area ({LandType}):</label>
                                            <Field type='text' name="leasedArea" className='form-control mb-2' onPaste={(e) => handlePaste(e)}
                                                onKeyPress={(e) => { AllowFloats(e); }} />

                                            <ErrorMessage name="leasedArea" component="div" className="text-error" />
                                        </bie.Col>
                                    </>) : (<></>)}
                                </bie.Row>
                                <div className="inner-herbpage-service-title-sub"><h1 className="mb-0"> Provide Registered document details</h1></div>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th> S.No</th>
                                                <th> SRO Sub Registrar Office Name	</th>
                                                <th> Registration Year</th>
                                                <th>Registered Document Number</th>
                                                <th> Registered Document Fetched from IGRS Link (Upload PDF) </th>

                                                <th>Action</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <FieldArray name="details">
                                                {(QualificationValues) => {
                                                    return QualificationValues?.form?.values?.details.map((qual, index) => {
                                                        return (
                                                            <>
                                                                <tr key={index}>
                                                                    <td>
                                                                        <center>{index + 1}</center>
                                                                    </td>
                                                                    <td>
                                                                        <div style={{ position: 'relative' }}>
                                                                            <Field as="select"
                                                                                className="form-control form-control-md"
                                                                                name={`details[${index}].sroSubRegistrarName`}
                                                                            >
                                                                                <option value=''>--select--</option>
                                                                                {SroData && SroData.map((dept, i) => (
                                                                                    <option value={dept?.sro_code}>{dept?.sro_name}</option>
                                                                                ))}

                                                                            </Field>
                                                                            <ErrorMessage name={`details[${index}].sroSubRegistrarName`} component="div" className="text-error" />
                                                                        </div>
                                                                    </td>
                                                                    <td>

                                                                        <Field as="select"
                                                                            maxLength={4}
                                                                            onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                                            className="form-control form-control-md"
                                                                            name={`details[${index}].regYear`}
                                                                            style={{ width: '15em' }}>

                                                                            <option value=''>---Select---</option>
                                                                            {getYearsDynamicBasedOnInput(1970).map(year => (
                                                                                <option key={year} value={year}>{year}</option>
                                                                            ))}

                                                                        </Field>
                                                                        <ErrorMessage name={`details[${index}].regYear`} component="div" className="text-error" />

                                                                    </td>
                                                                    <td>
                                                                        <Field type="text" onPaste={(e) => handlePaste(e)}
                                                                            className="form-control form-control-md"
                                                                            name={`details[${index}].regDocNo`} maxLength="30"
                                                                            style={{ width: '15rem' }} />
                                                                        <ErrorMessage name={`details[${index}].regDocNo`} component="div" className="text-error" />
                                                                    </td>

                                                                    <td>
                                                                        <bie.Row>
                                                                            <bie.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8} className='mb-2'>

                                                                                <input type="file" className="form-control" name={`details[${index}].regDocFromIgrs`} accept="application/pdf"
                                                                                    onChange={(e) => {
                                                                                        let filename = "regDocFromIgrs";
                                                                                        let path = "/Uploads/InspectionPDFs/2024/Inspection/";
                                                                                        ImagePdfBucket(e, RegDeedFormik, path, `details[${index}].regDocFromIgrs`, filename, "pdf");
                                                                                    }} />

                                                                                <ErrorMessage name={`details[${index}].regDocFromIgrs`} component="div" className="text-error" />
                                                                            </bie.Col>
                                                                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>
                                                                                {RegDeedFormik?.values?.details[index]?.regDocFromIgrs && <button type='button' className='btn btn-primary' onClick={() => { viewImage(RegDeedFormik?.values?.details[index]?.regDocFromIgrs) }}><FaEye size={20} /> </button>}

                                                                            </bie.Col>

                                                                        </bie.Row>
                                                                    </td>

                                                                    <td colSpan={2} align="center" className="col-md-1">
                                                                        {index > 0 && RegDeedFormik?.values?.details?.length > 1 ? (
                                                                            <button
                                                                                type="button"
                                                                                className="button-titile btn btn-sm btn-danger"
                                                                                onClick={() => QualificationValues.remove(index)} >
                                                                                <FaRegTrashAlt />
                                                                            </button>
                                                                        ) : <td></td>}

                                                                    </td>

                                                                </tr>
                                                            </>
                                                        );
                                                    });
                                                }}
                                            </FieldArray>
                                            <tr className='table-active'>
                                                <td className='text-end' colSpan={11} >
                                                    <FieldArray name="details">
                                                        {(formikFieldArray) => {
                                                            return formikFieldArray.form.values.details.map((LJP, i) => {
                                                                return (<>
                                                                    {(i === 0) ? <> <button type="button" className="button-titile btn btn-sm btn-success me-4"
                                                                        onClick={() => {
                                                                            formikFieldArray.push({
                                                                                sroSubRegistrarName: "",
                                                                                regYear: "",
                                                                                regDocNo: "",
                                                                                regDocFromIgrs: "",
                                                                            });
                                                                        }}>
                                                                        <VscDiffAdded></VscDiffAdded>
                                                                    </button> </> : ''}
                                                                </>)
                                                            })
                                                        }}
                                                    </FieldArray>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="button-cend pt-1 mb-3">
                                    <button type='submit' className='btn btn-success btn-sm float-end rounded mb-2'>Submit</button>
                                </div>
                            </bie.Row>
                        </Form>
                    </FormikProvider>
                </bie.Container>
            </bie.Container>



        </>
    )
}
